import { useLocation, Link as RouterLink } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useErrorBoundary } from 'react-error-boundary';
import { sendDataToAnalytics } from '../../utils/misFunctions';
import { useHealthyDealsDataContext } from '../HealthyDealsDataContextProvider/HealthyDealsData.context';

const BackLink = () => {
	const location = useLocation();
	const { showBoundary } = useErrorBoundary();
	const { setMainTitleTo, componentRootPath } = useHealthyDealsDataContext();

	const backLinkText = `Back to ${location?.state?.title ? location.state.title : setMainTitleTo}`;
	return (
		<Stack direction="row">
			<Stack pt={0.25}>
				<ArrowBackIcon fontSize="small" />
			</Stack>
			<Stack>
				<Link
					component={RouterLink}
					to={location?.state?.title ? -1 : componentRootPath}
					onClick={e => {
						try {
							sendDataToAnalytics({
								eventName: 'backLinkClick',
								eventData: { backLinkText },
							});
						} catch (error) {
							e.preventDefault();
							showBoundary(error);
						}
					}}
				>
					{backLinkText}
				</Link>
			</Stack>
		</Stack>
	);
};

export default BackLink;
